import type { Move } from "@dailywars/core/engine";

import { enemyPassTurn } from "./tutorialAiTurns";
import { finishCapture, goToNeutralCity, selectRiflemanForCapture } from "./tutorialCaptureSteps";
import {
  advanceSniperTooFar,
  attackWithLightTank,
  outOfRangeCoach,
  selectLightTank,
  selectSniper,
  snipeFromRange,
  undoWrongMove,
  victory,
} from "./tutorialCombatSteps";
import { combatBasicsInfo } from "./tutorialInfoSteps";
import {
  buildLightTank,
  buildRifleman,
  buildSniper,
  capacityInfo,
  incomeInfo,
  tutorialIntro,
} from "./tutorialProductionSteps";
import { COORDS, enemyUnit, isIdle } from "./tutorialStepHelpers";
import type { TutorialStep } from "./tutorialStepTypes";

export type { TutorialPrompt, TutorialStep } from "./tutorialStepTypes";

const { enemyBarracks } = COORDS;

const buildEnemyRpg: Move[] = [
  { type: "build", pos: enemyBarracks, unitKind: "rpgInfantry" },
  { type: "endTurn" },
];

const endTurnFirst: TutorialStep = {
  id: "end-turn-first",
  buildKind: null,
  enableEndTurn: true,
  aiTurnMoves: buildEnemyRpg,
  prompt: () => ({
    title: "End your turn",
    body: "Your Rifleman is built. Tap End Turn and watch the enemy take their turn.",
    highlight: { kind: "end-turn" },
  }),
  allowsTile: () => false,
  isComplete: (store) =>
    Boolean(enemyUnit(store.localState)) &&
    store.localState.currentPlayer === "p1" &&
    isIdle(store),
};

const endTurnSecond: TutorialStep = {
  id: "end-turn-second",
  buildKind: null,
  enableEndTurn: true,
  aiTurnMoves: enemyPassTurn,
  prompt: () => ({
    title: "End your turn again",
    body: "Your Sniper and Light Tank are ready. Tap End Turn to continue.",
    highlight: { kind: "end-turn" },
  }),
  allowsTile: () => false,
  isComplete: (store) =>
    store.localState.currentDay >= 3 && store.localState.currentPlayer === "p1" && isIdle(store),
};

export const TUTORIAL_STEPS: TutorialStep[] = [
  tutorialIntro,
  buildRifleman,
  capacityInfo,
  endTurnFirst,
  incomeInfo,
  selectRiflemanForCapture,
  goToNeutralCity,
  buildSniper,
  buildLightTank,
  endTurnSecond,
  finishCapture,
  selectLightTank,
  attackWithLightTank,
  combatBasicsInfo,
  selectSniper,
  advanceSniperTooFar,
  outOfRangeCoach,
  undoWrongMove,
  snipeFromRange,
  victory,
];
